<!--
  ApiLoading.vue

  This component should be used for content placeholder while
  api is loading/failed.

  @prop apiError {Boolean} - Represent if api failed or not. initially, it should always 'false'.
  @prop loadingMessage {String} @optional - Single line text message to display while api is loading.
  @prop titleScale {Number} @optional - Scale of how title size should be. Default to be 2. (<h4> size)
  @prop loadingTitle {String} @optional - Text that used as "title" of loading. Default to be "Loading..."
  @prop isMemberPortal {Boolean} @optional - if slot for error message isn't given, display default message with link to contact us. if is true, link to contact us uses vue router link otherwise use <a> which should be used for public website

  * slot can be passed for error message content (idealy a <p> or multiple of them.) otherwise it will always display "Oops, something has gone wrong. Please try again".
  
  * To control size or padding (padding default is 30px) of this component, you can give class and specify its width and height.
    This will result your class to applied to main wrapper <div> with "api-loading-wrapper" class.
    e.g. 
      <ApiLoading :apiError="true" class="your-class">
        <p>error message</p>
      </ApiLoading>
-->

<template>
  <div class="api-loading-wrapper">
    <div v-if="!apiError" class="loading-wrapper">
      <loading :titleScale="titleScale" :title="loadingTitle" />
      <p v-if="loadingMessage" v-html="loadingMessage"></p>
    </div>

    <div v-else class="error">
      <svg>
        <use xlink:href="/assets/public/images/icons.svg#error" />
      </svg>
      <slot v-if="!!$slots.default"></slot>
      <template v-else>
        <p v-if="isMemberPortal">
          Sorry, something has gone wrong, and we can’t show you all the information. Please try refreshing the page{{ isBuildCRM() ? '.' : '' }}
          <template v-if="!isBuildCRM()">
            or
            <router-link :to="{ name: CONTACT_US }" target="_blank">contact us</router-link>
            .
          </template>
        </p>
        <p v-else>
          Sorry, something has gone wrong, and we can’t show you all the information. Please try refreshing the page{{ isBuildCRM() ? '.' : '' }}
          <template v-if="!isBuildCRM()">
            or
            <a href="/support/contact-us" target="_blank">contact us</a>
            .
          </template>
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import { isBuildCRM } from '@/utils';
import { CONTACT_US } from '@/router/routeNames';
import loading from '@general/js/components/loading.vue';

export default {
  name: 'ApiLoading',

  props: {
    apiError: {
      type: Boolean,
      required: true,
    },
    loadingMessage: {
      type: String,
    },
    titleScale: {
      type: Number,
      default: 2,
    },
    loadingTitle: {
      type: String,
    },
    isMemberPortal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      CONTACT_US,
    };
  },

  components: {
    loading,
  },

  methods: {
    isBuildCRM,
  },
};
</script>

<style lang="scss" scoped>
.api-loading-wrapper {
  background: $PRIMARY_EGGSHELL_100;
  padding: 30px;
  display: flex;
  justify-content: center;
  min-height: 400px;

  .loading-wrapper {
    margin: auto;
    width: 100%;

    p {
      text-align: center;
    }
  }

  .error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;

    & > * {
      text-align: center;
    }

    svg {
      width: 28px;
      height: 28px;
      color: $GREY_800;
      margin: 0 auto 30px;
    }
  }
}
</style>
